import { BATCH_NAME } from 'constants/ActionTypes';

const initialState = {
  batchName: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case BATCH_NAME:
      return { ...state, batchName: action.payload };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./reducers/Batch.js